'use strict';

var _ = require('underscore');
var Backbone = require('backbone');
var validator = require('validator');
var moment = require('moment-timezone');
var Utils = require('../utilities/Utilities').default;
var polyglot = require('../utilities/polyglot').default;

var STATUSES = {
  BOOKED: 0,
  BOOKING_NOT_INTERESTED: 1,
  BOOKING_FAILED: 2,
};

export default Backbone.Model.extend({

  urlRoot: '/online_bookings/ajax_request/',

  showMobilePhone: function () {
    return window.SETTINGS.client_fields !== null && window.SETTINGS.client_fields.mobile_phone != 'na';
  },

  isMobilePhoneRequired: function () {
    return window.SETTINGS.client_fields !== null && window.SETTINGS.client_fields.mobile_phone == 'required';
  },

  isAdvancedWaitlistEnabled: function () {
    return window.SETTINGS.advanced_wait_list;
  },

  isStaffPickerHidden: function () {
    return !window.SETTINGS.show_staff_picker || window.SETTINGS.enable_builder;
  },

  isActive: function () {
    var location = this.get('location');
    var service = this.get('service');
    var user = this.get('user');

    return this.get('active')
      && (location && location.active)
      && (service && service.active)
      && (!this.get('staff_id') || (user && user.active));
  },

  isNotCancelled: function () {
    return this.get('active') !== false;
  },

  isNotBooked: function () {
    return this.get('appointment_id') === null;
  },

  getTimezone: function () {
    return this.get('client').timezone || this.get('location').timezone;
  },

  getTimezoneAbbr: function () {
    return moment().tz(this.getTimezone()).zoneAbbr();
  },

  validate: function (attrs, options) {
    var errors = {};

    if (!attrs.location_id) {
      errors.location_id = polyglot.t('forms.location.error');
    }

    if (!attrs.first_name) {
      errors.first_name = polyglot.t('forms.first_name.error');
    } else {
      if (attrs.first_name.match(Utils.SPECIAL_CHARS)) {
        errors.first_name = polyglot.t('forms.first_name.error.chars');
      }
    }

    if (!attrs.last_name) {
      errors.last_name = polyglot.t('forms.last_name.error');
    } else {
      if (attrs.last_name.match(Utils.SPECIAL_CHARS)) {
        errors.first_name = polyglot.t('forms.last_name.error.chars');
      }
    }

    if (!(attrs.email && validator.isEmail(attrs.email))) {
      errors.email = polyglot.t('forms.email.error');
    }

    var mobile = attrs.cell_phone;
    if (this.isMobilePhoneRequired() && (!mobile || (typeof mobile === 'string' && mobile.match(/[A-z]/g)))) {
      errors.cell_phone = polyglot.t('forms.cell_phone.error');
    }

    if (this.isAdvancedWaitlistEnabled()) {
      attrs.preferences.each((preference, index) => {
        if (!preference.isValid()) {
          errors[`preference-${index}`] = preference.validationError;
        }
      });
    }

    if (!this.isAdvancedWaitlistEnabled() && !attrs.request) {
      errors.request = polyglot.t('forms.request.error');
    }

    if (_.size(errors)) {
      return errors;
    }
  },

  isValidRequest: function () {
    return Backbone.ajax({
      method: 'GET',
      url: '/online_bookings/ajax_get_request',
      data: {
        request_id: this.get('id'),
      },
    });
  },

  cancel: function () {
    return Backbone.ajax({
      method: 'DELETE',
      url: '/online_bookings/ajax_cancel_request',
      data: {
        client_view_request: true,
        request_id: this.get('id'),
        _token: document.head.querySelector('meta[name="csrf-token"]').content,
      },
    });
  },
}, {
  STATUSES,
});
